export default __webpack_public_path__ + "KaTeX_Size4-Regular.1d1325964eb3838aa3086bb34e36a1cf.ttf";